module.exports = __webpack_public_path__ + "static/media/ALTHAR_telefarmcia.b580d58f.png";